/* eslint no-console: "off", quotes: "off" */
/* eslint-disable */
import { mapMutations } from 'vuex';

const PendingTimeRematch = {
  data() {
    return {
      TIME_LIMIT: null,
      WARNING_THRESHOLD: 30,
      ALERT_THRESHOLD: 10,
      TIME_PASSED: null,
      FULL_DASH_ARRAY: 283,
      CHALLENGE_WITH_BOT: false,
      timeLeft: null,
      timerInterval: null,
      remainingPathColor: null,
      COLOR_CODES: {
        info: {color: "LightSeaGreen"},
        warning: {color: "LightSalmon", threshold: this.WARNING_THRESHOLD},
        alert: {color: "FireBrick", threshold: this.ALERT_THRESHOLD}
      },
    };
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
  methods: {
    ...mapMutations('game', [
      'setToDefaultChallengeInfo',
    ]),
    ...mapMutations('common', [
      'unregisterModal',
    ]),
    initiateTimer(timeLimit, timePassed, challengeWithBotSoAfterTimeIsUpMustBeClosedProgrammatically) {
      this.TIME_LIMIT = timeLimit;
      this.TIME_PASSED = timePassed;
      this.CHALLENGE_WITH_BOT = challengeWithBotSoAfterTimeIsUpMustBeClosedProgrammatically;
      this.timeLeft = this.TIME_LIMIT;
      this.remainingPathColor = this.COLOR_CODES.info.color;
      document.getElementById("timer").innerHTML = `
  <div class="base-timer">
    <svg class="base-timer__svg" viewBox="0 0 100 100">
      <g class="base-timer__circle">
        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
        <path id="base-timer-path-remaining" stroke-dasharray="283" class="base-timer__path-remaining ${this.remainingPathColor}" d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"></path>
      </g>
    </svg>
    <span id="base-timer-label" class="base-timer__label">${this.formatTime(this.timeLeft)}</span>
  </div>
  `;
      this.startTimer()
    },
    onTimesUp() {
      if (this.timerInterval) {
        if (this.CHALLENGE_WITH_BOT) {
          this.$emit('close');
          this.setToDefaultChallengeInfo();
        }
        clearInterval(this.timerInterval);
      }
      // document.getElementById("base-timer-label").innerHTML = "Done";
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        this.TIME_PASSED = this.TIME_PASSED += 1;
        this.timeLeft = this.TIME_LIMIT - this.TIME_PASSED;
        // console.log(TIME_PASSED);
        if (document.getElementById("base-timer-label") != null)
          document.getElementById("base-timer-label").innerHTML = this.formatTime(this.timeLeft);
        this.setCircleDasharray();
        this.setRemainingPathColor(this.timeLeft);
        if (this.timeLeft === 0) {
          this.onTimesUp();
        }
      }, 1000);
    },
    formatTime(time) {
      let minutes = Math.floor(time / 60);
      // if (minutes < 10) {
      //   minutes = `0${minutes}`;
      // }
      let seconds = time % 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return `${minutes}:${seconds}`;
    },
    setRemainingPathColor(timeLeft) {
      const {alert, warning, info} = this.COLOR_CODES;
      if (timeLeft <= alert.threshold) {
        if (document.getElementById("base-timer-path-remaining")) {
          document.getElementById("base-timer-path-remaining").classList.remove(warning.color);
          document.getElementById("base-timer-path-remaining").classList.add(alert.color);
          document.getElementsByClassName("base-timer__label")[0].style.color = `${alert.color}`;
        }
      } else if (timeLeft <= warning.threshold) {
        if (document.getElementById("base-timer-path-remaining")) {
          document.getElementById("base-timer-path-remaining").classList.remove(info.color);
          document.getElementById("base-timer-path-remaining").classList.add(warning.color);
          document.getElementsByClassName("base-timer__label")[0].style.color = `${warning.color}`;
        }
      }
    },
    calculateTimeFraction() {
      const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
      return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
    },
    setCircleDasharray() {
      const circleDasharray = `${(this.calculateTimeFraction() * this.FULL_DASH_ARRAY).toFixed(0)} 283`;
      if (document.getElementById("base-timer-path-remaining"))
        document.getElementById("base-timer-path-remaining").setAttribute("stroke-dasharray", circleDasharray);
    },
  },
};

export default PendingTimeRematch;



// WEBPACK FOOTER //
// ./src/common/jQueryMixin.js